module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hideme"
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "paginationPadding": 10,
      "navigationEnabled": true,
      "autoplayTimeout": 5000,
      "loop": true
    }
  }, _vm._l((_vm.sliderContent), function(slide, idx) {
    return _c('slide', {
      key: idx
    }, [_c('div', {
      staticClass: "VueCarousel-slide"
    }, [_c('img', {
      attrs: {
        "src": _vm.exportImagePath(slide.image),
        "width": "100%",
        "alt": "The Shape of Water"
      }
    })])])
  }))], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48ba2050", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48ba2050","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderImage.vue
// module id = 401
// module chunks = 0